export const UPDATE_FILTERS = 'UPDATE_FILTERS';

export type FilterAction = {
  type: string;
  payload: filtersPayload;
};

export type filtersPayload = {
  pageName: string;
  environment: string;
  filters?: any;
};

export const updateFilters = (item: filtersPayload) => ({
  type: UPDATE_FILTERS,
  payload: item
});
